export const mergeSponsors = sponsors => {
  let mergedSponsors = []
  if (sponsors?.mediaSponsors?.data?.length)
    mergedSponsors = [...mergedSponsors, ...sponsors.mediaSponsors.data]
  if (sponsors?.partners?.data?.length) mergedSponsors = [...mergedSponsors, ...sponsors.partners.data]
  if (sponsors?.sponsors?.data?.length) mergedSponsors = [...mergedSponsors, ...sponsors.sponsors.data]
  return mergedSponsors
}
